import React, {useEffect, useMemo, useRef, useState} from 'react';
import { useFiltersSidebarCollapsed } from "../hooks/useFiltersSidebarCollapsed";
import PillActionButton from "../components/StocksLayout/PillActionButton";
import Transition from 'utils/Transition';

import { SlidingContainer } from 'components/SlidingContainer/SlidingContainer';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import {
    resetEditingRow,
    setIsNeedUpdateData,
    setIsWarehouseFormModalOpen,
    setEditingRow,
    setRowData
} from "../redux/warehouses/reducer";
import Actions from "../components/Tables/Actions/Actions";
import FormWarehouse from "../components/Forms/FormWarehouse/FormWarehouse";
import Table from "../components/Tables/WarehouseTable/Table";
import store from "../redux/store";
import {IRowData, ITableSettingsLegacy} from "../constants/Table/interfaces";
import warehousesService from "../api/services/warehousesService";
import {WarehouseType} from "../constants/Warehouses/WarehouseType";
import warehouseSourceStatus from "../constants/Warehouses/warehouseSourceStatus";
import {DataSourceStatus} from "../constants/DataSource/DataSourceStatus";
import StocksFilterSidebar, { FilterSidebarSection } from '../components/StocksLayout/StocksFilterSidebar';
import trashIcon from "../assets/images/trashBin.svg";
import Employee from "../components/Forms/FormWarehouse/Employees/Employee";
import Tabs from "../components/Tables/StocksFBSTable/Actions/Tabs";
import url from "../utils/UrlHelper";
import {Link} from "react-router-dom";
import rowsPerPageBasedOnViewport from "../utils/PaginationHelper";
import getFrequencyBySla from "../components/DataSources/FrequencyHelper";
import OpenStocksExportForm from "../components/Tables/StocksExportTable/Actions/OpenStocksExportForm";
import { ReactComponent as FilterFunnelIcon } from '../assets/icons/new/UI/FilterFunnel.svg';
import { ReactComponent as HideMenuIcon } from '../assets/icons/new/UI/HideMenu.svg';
import { ReactComponent as AddCircleFilledIcon } from '../assets/icons/new/UI/AddCircleFilled.svg';
import {setIsStocksExportFormModalOpen} from "../redux/stocksExport/reducer";
import FormStocksExport from "../components/Forms/FormStocksExport/FormStocksExport";

const { List, Body, Tab, Panel }: any = Tabs;

const Warehouses: React.FC = () => {
    const [loaded, setLoaded] = React.useState(false);

    const { sellerId, currentSellerInfo } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        currentSellerInfo: sellers.currentSeller.info,
    }))

    const editingRow = useAppSelector((state) => state.warehouses.editingRow);
    const isNeedUpdateData = useAppSelector((state) => state.warehouses.isNeedUpdateData);

    const [isNeedClearWarehouseForm, setIsNeedClearWarehouseForm] = React.useState<boolean>(false);
    const [currentFilter, setCurrentFilter] = React.useState<string>('active');

    //
    const isStocksExportFormModalOpen = useAppSelector((state) => state.stocksExport.isStocksExportFormModalOpen);

    const toOpenStocksExportFormModal = () => {
        store.dispatch(setIsStocksExportFormModalOpen(true));
    };

    const toCloseStocksExportFormModal = (e: UIEvent) => {
        e.stopPropagation();
        store.dispatch(setIsStocksExportFormModalOpen(false));
    };

    const toCloseStocksExportFormModalOnClickOutside = (e: UIEvent) => {
        e.stopPropagation();
        store.dispatch(setIsStocksExportFormModalOpen(false));
    };

    const contentRefExportForm = useRef<HTMLDivElement>(null);

    //
    const isWarehouseFormModalOpen = useAppSelector((state) => state.warehouses.isWarehouseFormModalOpen);

    const toOpenWarehouseFormModal = () => {
        store.dispatch(setIsWarehouseFormModalOpen(true));
    };

    const toCloseWarehouseFormModal = (e: UIEvent) => {
        e.stopPropagation();
        store.dispatch(setIsWarehouseFormModalOpen(false));
        dispatch(resetEditingRow())
        setIsNeedClearWarehouseForm(true)
    };

    const toCloseWarehouseFormModalOnClickOutside = (e: UIEvent) => {
        e.stopPropagation();
        store.dispatch(setIsWarehouseFormModalOpen(false));
        dispatch(resetEditingRow())
    };

    const contentRefWarehouseForm = useRef<HTMLDivElement>(null);


    const dispatch = useAppDispatch();

    if (isNeedUpdateData) {
        setTimeout(() => {
            store.dispatch(setIsNeedUpdateData(false))
        }, 6000);
    }

    const columnDataMock: any = useMemo(
        () => [
            { Header: 'Наименование', accessor: 'attributes.name', id: "name", sticky: "left", minWidth: 300, width: 300, maxWidth: 300},
            { Header: 'Тип', accessor: 'attributes.type', id: "type", minWidth: 150, },
            { Header: 'К продаже', accessor: 'attributes.isForSale', id: "isForSale", minWidth: 30, },
            { Header: 'В отправке', accessor: 'attributes.isEnableExport', id: "isEnableExport", minWidth: 30, },
            { Header: 'Источник', accessor: 'attributes.source', id: "source", minWidth: 50, },
            {
                Header: 'Частота обновления',
                accessor: 'attributes.sourceUpdateFrequency',
                id: "sourceUpdateFrequency",
            },
            { Header: 'Адрес', accessor: 'attributes.address', id: "address", minWidth: 100, },
        ],
        []
    );
    const [rowDataLoading, setRowDataLoading] = React.useState<boolean>(true);
    const [productsRequestError, setProductsRequestError] = React.useState<string>('');
    const [totalProducts, setTotalProducts] = React.useState<number>(0);
    const [tableSettings, setTableSettings] = React.useState<ITableSettingsLegacy>({
        limit: rowsPerPageBasedOnViewport() ?? 20,
        page: 1,
        filterBy: { data: { combinator: 'and', not: false, rules: [] } },
        sortBy: {},
        fields: []
    });
    const [tableSettingsLoaded, setTableSettingsLoaded] = React.useState<boolean>(true);
    const rowData = useAppSelector((state) => state.warehouses.rowData);
    let [isFirstRender, setIsFirstRender] = useState<boolean>(true);

    const editRow = (row: IRowData) => {
        dispatch(setEditingRow(row));
        toOpenWarehouseFormModal();
    };

    const rowsDataFormatter = (rows: any[]) => {
        const frequencyBySla: number = getFrequencyBySla(currentSellerInfo.data?.sla || '')

        let arrOfRows: any[] = [];
        rows.forEach((row: any) => {

            let source: { code: any; updateFrequency: number|null; status: DataSourceStatus }|null;
            switch (row.type) {
                case WarehouseType.FBS:
                    source = row.dataSources?.filter((v:any) => v.status === DataSourceStatus.Current)[0];
                    break;
                case WarehouseType.Supplier:
                    source = row.supplier?.dataSources?.filter((v:any) => v.status === DataSourceStatus.Current)[0];
                    break;
                default:
                    source = {code: row.externalService, status: DataSourceStatus.Current, updateFrequency: frequencyBySla}
            }

            if (row.name === 'Интегрированный склад API LK') {
                source = {code: 'integration', status: DataSourceStatus.Current, updateFrequency: null}
            }

            if (row.externalID.includes('se_spl')) {
                source = {code: 'LK' + (row.externalID.replace('se_spl_', '')), status: DataSourceStatus.Current, updateFrequency: null}
            }

            arrOfRows.push({
                id: row.uuid,
                attributes: {
                    uuid: row.uuid,
                    name: row.name,
                    type: row.type,
                    externalID: row.externalID,
                    status: row.status,
                    address: row.address,
                    source: source?.code,
                    isForSale: row.isForSale,
                    isEnableExport: row.isEnableExport,
                    // sourceUpdateFrequency: source?.updateFrequency,
                    sourceUpdateFrequency: source?.updateFrequency,
                    sourceConnectionStatus: source?.status,
                }
            })
        })
        return arrOfRows;
    }

    const useHasChanged = (val: any) => {
        const prevVal = usePrevious(val)
        return prevVal !== val
    }

    const usePrevious = (value: any) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }

    // Костыль чтобы запрос не выполнялся на каждый рендер
    let isChangedTableSettings = useHasChanged(tableSettings);
    let isChangedCurrentFilter = useHasChanged(currentFilter);
    let isChangedIsNeedUpdateData = useHasChanged(isNeedUpdateData);
    useEffect(() => {

        // Костыль чтобы запрос не выполнялся на каждый рендер
        if (isFirstRender) {
            isChangedTableSettings = false
            isChangedCurrentFilter = false
            isChangedIsNeedUpdateData = false
        }

        if (sellerId && (isFirstRender || isChangedTableSettings || isChangedCurrentFilter || (isChangedIsNeedUpdateData && isNeedUpdateData))) {
            warehousesService.getWarehousesForSeller(sellerId)
                .then(
                    (res) => {
                        if (res.data.success) {
                            const filteredRows = res.data.data.filter((v:any) => v.status === currentFilter)
                            const sortedRows = filteredRows.sort(
                                (a: any, b: any) => Number(new Date(b.createdAt)) - Number(new Date(a.createdAt)),
                            );
                            const data = sortedRows.slice(tableSettings.limit * (tableSettings.page - 1), tableSettings.page * tableSettings.limit)

                            const rows = rowsDataFormatter(data)
                            // @ts-ignore
                            dispatch(setRowData(rows))
                            setTotalProducts(sortedRows.length)
                            setRowDataLoading(false)
                        }
                    },
                    (err) => {
                        setProductsRequestError(err.response.data.error);
                        setRowDataLoading(false);
                    }
                )
                .catch((err) => {
                    setProductsRequestError(err.message);
                    setRowDataLoading(false);
                })
                .finally(() => setRowDataLoading(false))
            ;
        }

        // Костыль чтобы запрос не выполнялся на каждый рендер
        setIsFirstRender(false)
        isFirstRender = false
    }, [tableSettings, isNeedUpdateData, currentFilter]);


    const [selectedRows, setSelectedRows] = useState([]);
    const [sidebarCollapsed, setSidebarCollapsed] = useFiltersSidebarCollapsed();

    // @ts-ignore
    return (
        <div className="flex flex-col h-full">
                    {/*Actions start*/}
                    <Actions noMargin noBorder scrollable>
                        <div className="flex items-center justify-between w-full">
                            <div className="flex items-center">
                                <button
                                    onClick={() => setSidebarCollapsed(v => !v)}
                                    className="flex p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-gray-100 dark:hover:bg-[#1e293b] rounded transition-colors flex-shrink-0"
                                    title={sidebarCollapsed ? 'Показать фильтры' : 'Скрыть фильтры'}
                                >
                                    {sidebarCollapsed
                                        ? <FilterFunnelIcon width={20} height={20} style={{ fill: 'currentColor' }} />
                                        : <HideMenuIcon width={20} height={20} style={{ fill: 'currentColor' }} />
                                    }
                                </button>
                                <Tabs selected={`warehouses`}></Tabs>

                                <div className="ml-3 flex items-center gap-1">
                                    <PillActionButton
                                        icon={AddCircleFilledIcon}
                                        label="Добавить склад"
                                        onClick={toOpenWarehouseFormModal}
                                    />
                                    <OpenStocksExportForm toOpenStocksExportFormModal={toOpenStocksExportFormModal}></OpenStocksExportForm>
                                </div>
                            </div>
                        </div>
                    </Actions>
                    {/*Actions end*/}

                    <div className={'flex flex-1 min-h-0'}>
                        {/*Filter start*/}
                        {!sidebarCollapsed && (
                            <div className="hidden lg:flex">
                                <StocksFilterSidebar
                                    sections={[
                                        {
                                            id: 'status',
                                            summaryItem: { key: 'active', label: 'Все' },
                                            defaultOpen: true,
                                            items: [
                                                { key: 'deleted', label: 'В архиве' },
                                            ],
                                        },
                                    ]}
                                    activeFilter={currentFilter}
                                    onChange={setCurrentFilter}
                                />
                            </div>
                        )}
                        {/*Filter end*/}

                        {/*Table start*/}
                        <Table
                            columns={columnDataMock}
                            tableSettingsLoaded={tableSettingsLoaded}
                            totalProducts={totalProducts}
                            tableSettings={tableSettings}
                            setTableSettings={setTableSettings}
                            data={rowData}
                            rowDataLoading={rowDataLoading}
                            productsRequestError={productsRequestError}
                            editRow={editRow}
                            setSelectedRows={setSelectedRows}
                        />
                        {/*Table end*/}

                    </div>
            <SlidingContainer
                //@ts-ignore
                title={editingRow ? ([WarehouseType.ExternalWarehouseFBO,WarehouseType.ExternalWarehouseFBS].includes(editingRow.attributes.type) ? 'Просмотр склада' : 'Редактировать склад') : 'Новый склад'}
                id="warehouse-form-modal"
                modalOpen={isWarehouseFormModalOpen}
                toCloseModal={toCloseWarehouseFormModal}
                toCloseModalOnClickOutside={toCloseWarehouseFormModalOnClickOutside}
                modalContent={contentRefWarehouseForm}
                minWidth={680}
            >
                {/*@ts-ignore*/}
                <FormWarehouse
                    /*@ts-ignore*/
                    isNeedClearWarehouseForm={isNeedClearWarehouseForm}
                    setIsNeedClearWarehouseForm={setIsNeedClearWarehouseForm}
                />
            </SlidingContainer>
            <SlidingContainer
                //@ts-ignore
                title="Настройка отправки и синхронизации остатков"
                id="stocks-export-form-modal"
                modalOpen={isStocksExportFormModalOpen}
                toCloseModal={toCloseStocksExportFormModal}
                toCloseModalOnClickOutside={toCloseStocksExportFormModalOnClickOutside}
                modalContent={contentRefExportForm}
                minWidth={760}
            >
                <FormStocksExport></FormStocksExport>
            </SlidingContainer>

            {/* Mobile/tablet filter drawer — visible on < 1024px when sidebar open */}
            {/* @ts-ignore */}
            <Transition
                className="fixed inset-0 bg-gray-900 bg-opacity-30 z-[70] lg:hidden"
                show={!sidebarCollapsed}
                enter="transition ease-out duration-200"
                enterStart="opacity-0"
                enterEnd="opacity-100"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
                aria-hidden="true"
                appear={undefined}
                onClick={() => setSidebarCollapsed(true)}
            />
            {/* @ts-ignore */}
            <Transition
                className="fixed inset-y-0 left-0 z-[70] lg:hidden w-[280px] max-w-[85vw] flex flex-col bg-[#d3ddec] dark:bg-[#1e293b] shadow-xl"
                show={!sidebarCollapsed}
                enter="transition ease-in-out duration-200 transform"
                enterStart="-translate-x-full"
                enterEnd="translate-x-0"
                leave="transition ease-in-out duration-200 transform"
                leaveStart="translate-x-0"
                leaveEnd="-translate-x-full"
                appear={undefined}
            >
                <div className="flex items-center justify-between px-3 py-3 border-b border-[#bccce3] dark:border-slate-700 shrink-0">
                    <span className="text-sm font-bold text-[#1E293B] dark:text-slate-100">Фильтры</span>
                    <button
                        className="text-gray-400 hover:text-gray-500 dark:text-slate-400 dark:hover:text-slate-300 bg-[#F1F5F9] dark:bg-slate-700 p-2 rounded-full cursor-pointer transition-colors"
                        onClick={() => setSidebarCollapsed(true)}
                    >
                        <svg className="w-3 h-3 fill-current">
                            <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
                        </svg>
                    </button>
                </div>
                <div className="flex-1 overflow-auto">
                    <StocksFilterSidebar
                        sections={[
                            {
                                id: 'status',
                                summaryItem: { key: 'active', label: 'Все' },
                                defaultOpen: true,
                                items: [
                                    { key: 'deleted', label: 'В архиве' },
                                ],
                            },
                        ]}
                        activeFilter={currentFilter}
                        onChange={(key) => {
                            setCurrentFilter(key);
                            setSidebarCollapsed(true);
                        }}
                        fluid
                    />
                </div>
            </Transition>
        </div>
    );
};

export default Warehouses;
